export default {
  ADD_NOTE: 'ADD_NOTE',

  SET_INPUT_NAME: 'SET_INPUT_NAME',
  SET_INPUT_MAIL: 'SET_INPUT_MAIL',
  SET_INPUT_MESSAGE: 'SET_INPUT_MESSAGE',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  RESET_INPUT: 'RESET_INPUT',
};
